import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionMotorcyclePermissions extends BaseScenesPermissions {}

export default EmissionMotorcyclePermissions
